import tzLookup from "@photostructure/tz-lookup";
import type { Coords } from "@/types/places";

/**
 * IANA time zone for an event, derived from its venue coordinates, so
 * times render as wall-clock time at the venue rather than in the
 * server's time zone. Returns undefined (caller falls back to the
 * server default) when the event has no usable coordinates.
 */
export function getEventTimeZone(event: {
  location?: Coords | null;
}): string | undefined {
  const { lat, lon } = event.location ?? {};
  if (typeof lat !== "number" || typeof lon !== "number") {
    return undefined;
  }
  try {
    return tzLookup(lat, lon);
  } catch {
    // tz-lookup throws on out-of-range coordinates
    return undefined;
  }
}
